export default __webpack_public_path__ + "static/media/photo--lg--group-wide.ece3d68e.jpg";